/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ForYouReasonKey } from './ForYouReasonKey';
import {
    ForYouReasonKeyFromJSON,
    ForYouReasonKeyFromJSONTyped,
    ForYouReasonKeyToJSON,
    ForYouReasonKeyToJSONTyped,
} from './ForYouReasonKey';

/**
 * A reason contributing to the For You personalization score
 * @export
 * @interface ForYouReason
 */
export interface ForYouReason {
    /**
     * 
     * @type {ForYouReasonKey}
     * @memberof ForYouReason
     */
    key: ForYouReasonKey;
    /**
     * Human-readable reason label
     * @type {string}
     * @memberof ForYouReason
     */
    label: string;
}



/**
 * Check if a given object implements the ForYouReason interface.
 */
export function instanceOfForYouReason(value: object): value is ForYouReason {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function ForYouReasonFromJSON(json: any): ForYouReason {
    return ForYouReasonFromJSONTyped(json, false);
}

export function ForYouReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): ForYouReason {
    if (json == null) {
        return json;
    }
    return {
        
        'key': ForYouReasonKeyFromJSON(json['key']),
        'label': json['label'],
    };
}

export function ForYouReasonToJSON(json: any): ForYouReason {
    return ForYouReasonToJSONTyped(json, false);
}

export function ForYouReasonToJSONTyped(value?: ForYouReason | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': ForYouReasonKeyToJSON(value['key']),
        'label': value['label'],
    };
}

